import { gql } from "@apollo/client";

export const DOOR_SIZES = gql`
  {
    doorSizes {
      doorSizeId
      doorSize
    }
  }
`;
